<template>
  <div class="container full">
    <el-container>
      <el-aside width="205px">
        <MyLeft />
      </el-aside>
      <el-container>
        <el-header>
          <MyHeader />
        </el-header>
        <el-main><MyMain :url="comhttp+url"/></el-main>  
      </el-container>
    </el-container>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader.vue";
import MyLeft from "@/components/MyLeft.vue";
import MyMain from "@/components/MyMain.vue";
import { mapActions, mapState } from "vuex";
import axios from "axios";

export default {
  name: "index",
  components: {
    MyHeader,
    MyLeft,
    MyMain
  },
  data() {
    return {
      loginname: "",
      pass: "",
      transitionName: ""
    };
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    }
  },
  mounted() {
    window.wx_login = this.wx_login;
    window.wx_login_ok = this.wx_login_ok;
  },
  computed: {
    ...mapState(["toUser","comhttp","url"]), 
  },
  methods: {
    ...mapActions(["setUserInfo", "setFromUser"]),
    login() {
      if (!this.valid.r) {
        this.$toast(this.valid.msg);
        return;
      }
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: "登录中..."
      });
      if (this.loginname !== "admin" || this.pass !== "admin123456") {
        this.$toast.clear();
        this.$toast("登录失败，账号或密码错误！");
        return;
      }
      var userInfo = {
        id: "",
        nickname: "测试账号",
        fromUser: "ooMCTxCheMDtrThY-Qu2f_sa0754"
      };
      this.setUserInfo(userInfo);
      this.setFromUser("ooMCTxCheMDtrThY-Qu2f_sa0754");
      this.$toast.clear();
      this.$toast("登录成功");
      this.goBack();
    },
    wx_login() {
      android.wx_login("wx_login_ok");
    },
    wx_login_ok(uid) {
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: "登录中..."
      });
      axios
        .get("/wwz/wwzajax!android_login.action", {
          params: {
            uid: uid,
            toUser: this.toUser
          }
        })
        .then(response => {
          this.$toast.clear();
          if (response.data.data != null) {
            this.setUserInfo(response.data.data);
            this.setFromUser(response.data.data._id);
            this.goBack();
          } else {
            this.$toast("登录失败");
          }
        })
        .catch(function(error) {
          window.console.log(error);
        });
    },
    goBack() {
      //返回对应的跳转URL
      var that = this;
      window.setTimeout(function() {
        if (
          that.$route.params.backurl === undefined ||
          that.$route.params.backurl == "" ||
          that.$route.params.backurl == null
        ) {
          that.$router.push({ name: "bbslist" });
        } else {
          that.$router.push({
            name: that.$route.params.backurl,
            query: that.$route.query
          });
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/basic.scss";
.container{
  .el-container{
    height: 100%;
  }
}
</style> 
